import { render, staticRenderFns } from "./CopyrightProductItem.vue?vue&type=template&id=cc634f00&scoped=true&"
import script from "./CopyrightProductItem.vue?vue&type=script&lang=js&"
export * from "./CopyrightProductItem.vue?vue&type=script&lang=js&"
import style0 from "./CopyrightProductItem.vue?vue&type=style&index=0&id=cc634f00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc634f00",
  null
  
)

export default component.exports